import { IDaySchedule, IPlanRange } from "@services/getMinerList";
import dayjs from "dayjs";
import { ICalendarProps } from "./Calendar/Calendar.props";

const FORMAT = "DD/MM/YYYY";

const SAVE_PLAN_TEMPLATE_KEY = "saved-plans";

export const filterDays = (days?: string[], bool = false) => {
  if (!days) return [];
  return days.filter((d) => {
    return dayjs(d, FORMAT).isValid() === bool;
  });
};

export type SlicedPeriods = {
  //first: string[][];
  //second: string[][];
  before: IPlanRange[];
  after: IPlanRange[];
  middle: IPlanRange[];
}

// ожидает корректный набор периодов, с одним переходом
export const getPeriodsAfterSkip = (periods: IPlanRange[]): SlicedPeriods => {
  const result: SlicedPeriods = {
    before: [],
    after: [],
    middle: [],
  };
  let beforeIdx = -1;
  let afterIdx = -1;
  for (let i = 0; i < periods.length; i++) {
    if (periods[i].time[0] === "" && i > 0) {
      result.before = periods.slice(0, i);
      beforeIdx = i;
    }
    if (periods[i].time[1] === "" && i < periods.length - 1) {
      result.after = periods.slice(i + 1, periods.length);
      afterIdx = periods.length;
    }
  }
  if (afterIdx !== -1 || beforeIdx !== -1) {
    if (afterIdx > -1 && beforeIdx > -1) {
      if (afterIdx !== beforeIdx) {
        result.middle = periods.slice(beforeIdx, afterIdx - 1);
      }
    } else {
      if (afterIdx === -1) {
        result.middle = periods.slice(afterIdx, periods.length);
      } else {
        result.middle = periods.slice(0, beforeIdx);
      }
    }
  }
  return result;
}

export const checkingOverlapPeriods = (periods: [string, string][]) => {

  function timeToMinutes(time: string) {
    if (time === "") return NaN;
    const [hours, minutes] = time.split(":").map(Number);
    return hours * 60 + minutes;
  }

  function periodsIntersect(period1: string[], period2: string[]) {
    const [start1, end1] = period1.map(timeToMinutes);
    const [start2, end2] = period2.map(timeToMinutes);

    // Проверяем, пересекаются ли периоды
    //return (start1 < end2 || start2 < end1); //|| (end2 < end1);
    let p1 = start2 < end1;
    let p2 = end2 < end1;

    // console.log("Minutes", { p1, p2 });
    return (p1 || p2); //|| (end2 < end1);
  }

  for (let i = 0; i < periods.length; i++) {
    for (let j = i + 1; j < periods.length; j++) {
      if (periodsIntersect(periods[i], periods[j])) {
        return true;
      }
    }
  }

  return false;
};

// export const onSaveTemplate = (template: string[][]) => {
//   localStorage.setItem(SAVE_PLAN_TEMPLATE_KEY, JSON.stringify(template));
// };

// export const getSavedTemplates = () => {
//   const t = localStorage.getItem(SAVE_PLAN_TEMPLATE_KEY);
//   if (!t) return [];
//   return JSON.parse(t) as string[][];
// };

export const makeDatesToString = (dates?: IDaySchedule[]) => {
  return dates?.map((d) => d.day) || [];
};

export function formatWithoutTz(date: Date): string {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day < 10 ? "0" + day : day}/${month < 10 ? "0" + month : month}/${year}`
}

export function formatHhMmWithoutTz(
  date: Date,
  is12hours: boolean = false
): string {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  if (is12hours) {
    return `${hours % 12 || 12}:${minutes < 10 ? "0" + minutes : minutes} ${hours < 12 ? "AM" : "PM"}`;
  }
  return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}`;
}

export function parseDateFromFormat(
  value: string
): Date {
  if (value.length !== FORMAT.length) throw Error("Incorrect date format");
  const ddmmyyyy = value.split("/");
  if (ddmmyyyy.length !== 3) throw Error("Incorrect date format");
  const result = new Date();
  result.setFullYear(
    parseInt(ddmmyyyy[2]),
    parseInt(ddmmyyyy[1]) - 1,
    parseInt(ddmmyyyy[0])
  );
  result.setHours(0);
  result.setMinutes(0);
  result.setSeconds(0);
  result.setMilliseconds(0);
  return result;
}
